
import { Mql } from '@deqo/mql-js';
import { tryAnd } from '../../../CodesThatsGottaGoSomewhereElse';
import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { inCommands } from '../../../concepts/commands/CommandRegistry';
import { EditorSession } from '../../canvas/EditorSession';
import { CreateLensInfo, LensInfo } from './LensInfo';

export const lensApply = defineCommand(
    'lensApply',
    null,
    (cc, [type, query]: any[]) => {
        query = tryAnd(() => JSON.parse(`"${query}"`)) || query;

        const session = cc.call(EditorSession);

        const filter = Mql.compile(query);
        session.update(LensInfo, CreateLensInfo(type, filter));
    }
);

export const lensReset = defineCommand(
    'lensReset',
    null,
    (cc) => {
        const session = cc.call(EditorSession);
        session.update(LensInfo, LensInfo.empty);
    }
);

export const inLensCommands = () => inCommands(
    lensApply, lensReset,
);

